// 9fbef606107a605d69c0edbcd8029e5d 
module.exports = process.browser ? require('./clientLogger') : require('./serverLogger');
